import { Component } from '@angular/core';
import { PatientService } from '../services/patient.service';

@Component({
  selector: 'app-patient-pagination',
  templateUrl: './patient-pagination.component.html'
})
export class PatientPaginationComponent {
  constructor(public service: PatientService) { }

  onPaginate(page: number) {
    this.service.currentPage = page;
    this.service.search();
  }
}
